import React, { useContext, useState } from "react";
import Slider from "react-slick";
import Images from "../../Helpers/Images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Form, InputGroup } from "react-bootstrap";
import { EyeFill, EyeSlashFill, Facebook } from "react-bootstrap-icons";
import ThemeButtom from "../../Components/ThemeButtom";
import { Link, useNavigate } from "react-router-dom";
import { Notification, Placeholder, useToaster } from "rsuite";
import hasError from "../../Helpers/ErrorHelper";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Auth } from "../../Contexts/AuthContext";

const BrandLogin = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const [showPassword, setShowPassword] = useState(false);
  const { setAuth, setFavoriteCounts } = useContext(Auth);
  const [formData, setFormData] = useState({
    email: "qa@gmail.com",
    password: "123456789",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [validataionErrors, setValidataionErrors] = useState([]);
  const toaster = useToaster();
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const collect = {
      ...formData,
      [name]: value,
    };

    const IsError = validataionErrors?.find((v) => v.field == name);
    console.log("is : ", IsError);
    if (IsError !== undefined) {
      const errors = validataionErrors?.filter((v) => v.field !== name);
      setValidataionErrors(errors);
    }

    setFormData(collect);
  };
  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let confing = {
      url: ApiUrl.brandLogin,
      method: "POST",
      body: {
        email: formData?.email,
        password: formData?.password,
      },
    };

    APIRequest(
      confing,
      (res) => {
        setIsLoading(false);
        navigate("/brand-dashboard");
        localStorage.setItem("token", res?.token);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("userRole", "BRAND");
        setFavoriteCounts(res?.total_favorite_counts);
        localStorage.setItem("favCounts", res?.total_favorite_counts);
        setAuth({
          userRole: "BRAND",
          user: res.user,
          token: res?.token,
        });
        window.location.reload();
      },
      (err) => {
        setIsLoading(false);
        if (err.response.status === 422)
          setValidataionErrors(err.response.data.errors);
        else if (err.response.status === 401) {
          // setValidate(true);
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                type="error"
                header="Error"
                style={{ width: 100, color: "red" }}
                rows={0}
              />
              Invalid credentials
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        } else alert(err?.message);
      }
    );
  };
  return (
    <div className="login-wrapper">
      <div className="login-wrapper-inner">
        <div className="left">
          <Slider {...settings}>
            <div className="slider-box">
              <img src={Images.loginSlider1} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider2} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider3} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider4} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
          </Slider>
        </div>
        <div className="right">
          <img className="logo" src={Images.logo} alt="logo" />
          <p>Welcome to Dream Star !</p>
          <Form>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={formData?.email}
                placeholder="Enter email"
                name="email"
                onChange={handleOnChange}
              />
              {hasError(validataionErrors, "email")}
            </Form.Group>
            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  value={formData?.password}
                  placeholder="Password"
                  name="password"
                  onChange={handleOnChange}
                />
                <InputGroup.Text onClick={togglePasswordVisibility}>
                  {showPassword ? <EyeSlashFill /> : <EyeFill />}
                </InputGroup.Text>
              </InputGroup>
              {hasError(validataionErrors, "password")}
            </Form.Group>
            <Form.Group
              className="mb-3 forgot-btn"
              controlId="formBasicForgotPassword"
            >
              <Form.Text className="text-muted">
                <Link to="/forgot-password">Forgot Password?</Link>
              </Form.Text>
            </Form.Group>
            <ThemeButtom title="Login" handleClick={handleLogin} />
            <p className="button-middle-border">OR</p>
            {/* <Button className="facebook-btn">
              <Facebook size={20} className="me-2" />
              Login with Facebook
            </Button> */}
            <Form.Group
              className="mb-3 second-login-btn"
              controlId="formBasicForgotPassword"
            >
              <Form.Text className="text-muted">
                <Link to="/">Login As Influencer?</Link>
              </Form.Text>
            </Form.Group>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default BrandLogin;
